/*
 * @Description: 活动中心报名审核api
 * @Author: liuwp
 * @Date: 2022-09-09 16:52:55
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-13 14:44:15
 */
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 外部游客列表
export const outerListApi = (acId, params) => {
  return apiBaseUrl.get(`/ac/admin/guest/${acId}/outer-list`, params);
};

// 外部游客删除
export const deleteExternalerApi = (data) => {
  return apiBaseUrl.delete('/ac/admin/guest/outer', {
    data
  });
};

// 选人组件-游客列表
export const outerSelectListApi = (acId) => {
  return apiBaseUrl.get(`/ac/admin/guest/module/${acId}/guestlist`);
};

// 导入外部游客
export const addExternalerApi = (themeId, data) => {
  return apiBaseUrl.post(`/ac/admin/guest/${themeId}/addOuter`, data);
};
